import { useCallback, useContext } from "react";
import { useMultipartPostMutation } from "../../api/BaseEntityApi";
import {
  Dataset,
  DatasetForUpdateWriteModel,
  // DatasetFilters,
  DatasetForUploadWriteModel,
  datasetsConstants,
  DatasetSearchRequest,
  DatasetSearchResult,
  FormatFileState,
  // IsDatasetKnown,
} from "../../api/Datasets";
import { SessionContext } from "../../common/contexts/SessionContext";
import { DatasetResult } from "./FileFormatAutoDetection";
import { IResultModel } from "../../api/GenericTypes";
import { ResourceName } from "../../main/Routing";
interface FilesEditResponse {
  state: FormatFileState;
  size?: number;
  mtime?: number;
  path: string;
}
type DatasetFileAction = "add" | "delete";

export interface FilesEditInputSchema {
  fileActions: {
    files: {
      id: string;
      mtime: number;
      path: string;
      action: DatasetFileAction;
    }[];
  };
}

export const useDatasetUploadUtils = (datasetId: Dataset["id"]) => {
  const fileEditMutation = useMultipartPostMutation<FilesEditResponse[]>(
    `${datasetsConstants.resource}/${datasetId}/files/edit` as ResourceName
  ); // expects FilesEditInputSchema as body

  const updateDatasetMutation = useMultipartPostMutation<IResultModel<Dataset>>(
    `${datasetsConstants.resource}/${datasetId}/update` as ResourceName
  );

  return { fileEditMutation, updateDatasetMutation };
};

export const useFileUploadUtils = () => {
  const { api } = useContext(SessionContext);
  const uploadMutation = useMultipartPostMutation<IResultModel<Dataset>>("datasets/create");
  const updateMutation = useMultipartPostMutation<IResultModel<Dataset>>("datasets/update");

  const findDatasets = useCallback(
    async (payload: DatasetSearchRequest) => {
      const response: DatasetSearchResult[] = await api.post("datasets/find", payload);
      return response;
    },
    [api]
  );

  const generateDatasetSubmissionMultiForm = useCallback(
    (dataset: DatasetResult, metaData: DatasetForUploadWriteModel | DatasetForUpdateWriteModel) => {
      const body = new FormData();
      body.append("Dataset", JSON.stringify(metaData));
      dataset.files
        .filter((f) => f.id) //We filter out "ghost" items, as are injected when a file is deleted but we still want to display it
        .forEach((f) => body.append("files", f.file, f.id));
      return body;
    },
    []
  );

  return {
    findDatasets,
    uploadMutation,
    updateMutation,
    generateDatasetSubmissionMultiForm,
  };
};
